import React from 'react'
import KnowledgeCardStencil from './KnowledgeCardStencil'
import StencilBox from '../../stencils/StencilBox'
import { Link } from 'react-router-dom'

function SalesforceKnowledgeCardStencil() {
    return (
        <div className="edu-course-area eduvibe-home-five-course edu-section-gap">
            <div className="container">
                <div className="row g-5 ">
                    <div className="col-lg-5">
                        <div className="section-title text-start">
                            <StencilBox
                                className="pre-title stencil-sm-devic mb--10"
                                width="50%"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                            <StencilBox
                                className="pre-title stencil-sm-devic"
                                width="90%"
                                height="56px"
                                backgroundColor="#F5F5F5"
                            />
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="button-group isotop-filter filters-button-group d-flex justify-content-start justify-content-lg-end">
                            <Link className="edu-btn-stencil">
                                <StencilBox
                                    className="sf-blog-btn-stencil"
                                    width="223px"
                                    height="60px"
                                    backgroundColor="#F5F5F5"
                                />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row g-5 y-gap-30 mt--10 text-center">
                    {[0, 1, 2, 3, 4, 5]?.map((item) => (
                        <div key={item?.id} className="col-12 col-xl-4 col-lg-4 d-flex justify-content-center">
                            <KnowledgeCardStencil />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default SalesforceKnowledgeCardStencil
